module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_intro"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("Introduction")])]), _c('h1', {
    staticClass: "pre_stit"
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "image",
      "id": "apfi1_2",
      "src": "images/tit.jpg"
    }
  })])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif retrait_gauche"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("herever one looks in the church today, there is an evident need for a deeper work of the Holy Spirit.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("In the West, the old concept of “Christendom,” which has lasted for centuries, seems to be rapidly dying, as more and more people repudiate the faith of their fathers. In the sixties, attempting to reinterpret the gospel to the modern age, secular theologians openly denied the fundamentals of historic Christianity. Having largely lost the Christian faith, the Western world has lost the Christian ethic also. Society is now confessedly pluralist and permissive. The institution of the church survives, but is regarded by most people as a relic from the past, an outmoded structure like the superstitions to which it clings. Meanwhile, there are some signs of spiri")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("tual renewal—pockets of fresh vigor in the older denominations, in the house church movement and in parachurch organizations. Yet the general picture remains one of steadily diminishing Christian influence in an increasingly secular community. The dead, dry bones of the church need the living breath of God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("In some other parts of the world, it is true, the church is growing rapidly. At the International Congress on World Evangelization in Lausanne in July 1974 we heard of “an unprecedented receptivity to the Lord Jesus Christ.” Multitudes are flocking into the church, and in some areas, the Christian birthrate is higher than the population birthrate. All this gives great cause for rejoicing. At the same time, these people’s movements are sometimes marred, as in the days of the early church, by rivalries and factions, by false teaching and by superﬁcial emotionalism. So here, too, we see the need for a deeper work of the Holy Spirit, since he is the author of unity, truth and maturity.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("It is not only, however, when we look at the older churches of the Western world and the younger churches of the Third World that we see the need of the Holy Spirit. It is also when we look at ourselves. Surely all of us who say we belong to the Lord Jesus, whatever our particular persuasion may be, must be oppressed at times by our personal failures in Christian life and Christian ministry. We are conscious that we fall short of the standards of Christ, of the experience of the ﬁrst Christians and of the plain promises of ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("God in his Word. We are thankful indeed for what God has done and is doing, and we do not want to denigrate his grace by minimizing it. But we hunger and thirst for more. We also long for true revival, an altogether supernatural visitation of the Holy Spirit in the church, bringing depth as well as growth; and meanwhile we yearn for a deeper, richer, fuller experience of Christ through the Holy Spirit in our own lives.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIC")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROACH")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("As we approach this study, let me make four introductory points.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("First, our common desire and duty as Christians must be to enter into the full purpose of God for us. Nothing less than this will please him; so nothing less than this should please us. All of us who claim to follow Christ should seek a clearer understanding of God’s purpose for his people, should be moved to penitence by our failures to attain it, and should keep pressing on eagerly, longing to lay hold ﬁrmly and fully of everything for which Christ has laid hold of us (see Phil 3:12-14).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Second, we are to discover this purpose of God in Scripture. The will of God for the people is in the Word of God. It is here that we are to learn it, and not primarily from the experience of particular individuals or groups, however true and valid these experiences may be. We should neither covet for ourselves what God may have given to others, nor urge ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("upon others what God may have given to us, unless it is plainly revealed in his Word that this is part of the inheritance promised to all his people. What we seek for ourselves, and what we teach to others, must be governed by the Scripture alone. Only when the Word of God dwells in us richly shall we be able to evaluate the experiences that we and others may have. Experience must never be the criterion of truth; truth must always be the criterion of experience.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Third, this revelation of the purpose of God in Scripture should be sought primarily in its "), _c('i', [_vm._v("didactic ")]), _vm._v("rather than its "), _c('i', [_vm._v("descriptive ")]), _vm._v("parts. More precisely, we should look for it in the teaching of Jesus, and in the sermons and writings of the apostles, rather than in the purely narrative portions of the Acts. What is described in Scripture as having happened to others is not necessarily intended for us, whereas what is promised to us we are to appropriate, and what is commanded to us we are to obey.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("It would be easy to misunderstand the point I am trying to make. I am "), _c('i', [_vm._v("not ")]), _vm._v("saying that the descriptive passages of the Bible are valueless, for “all Scripture is inspired by God and proﬁtable” (2 Tim 3:16). What I "), _c('i', [_vm._v("am ")]), _vm._v("saying is that what is descriptive is valuable only insofar as it is interpreted by what is didactic. Some of the biblical narratives, which describe events, are self-interpreting because they include an explanatory comment, whereas others cannot be interpreted in isolation but only by the light of doctrinal or ethical teaching that is given elsewhere.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Thus, Paul tells us that the things that Israel experienced in the wilderness “happened to them as a warning” and “were written down for our instruction” (1 Cor 10:11; cf. Rom 15:4). He is referring to several episodes in which God’s judgment fell upon them. Here, then, are narrative passages that are proﬁtable for teaching. Yet their value lies not simply in the description, but in the explanation. We are to avoid idolatry, immorality, presumption and grumbling, he says, for these things are grievously offensive to God. How do we know? Because God’s judgment overtook them, as Moses clearly indicates in the stories, and as he and the prophets teach elsewhere. We must not, however, deduce from these stories that if we sin in these ways we too shall die by plague or snakebite as they did. Similarly, we can learn from the story of Ananias and Sapphira in Acts 5 that lying is very displeasing to God, for Peter says so; but we cannot assume that, like them, all liars will drop down dead.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Here is another example. In two separate paragraphs of the Acts, Luke tells us that the early Christians in Jerusalem sold many of their possessions, held the rest in common, and distributed goods and money “as any had need” (2:44, 45; 4:32-37). Are we to deduce from this that they set a pattern that all Christians are meant to copy and that private property is forbidden to Christians? Some groups have thought so. Certainly the generosity and mutual care of those early Christians are to be followed, for the New Testament commands us many times to love and serve one another, and to ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("be generous (even sacriﬁcial) in our giving. But to argue from the practice of the early Jerusalem church that all private ownership is abolished among Christians not only cannot be maintained from Scripture but is plainly contradicted by the apostle Peter in the same context (Acts 5:4) and by the apostle Paul elsewhere (e.g., 1 Tim 6:17). This example should put us on the alert. We must derive our standards of belief and behavior from the teaching of the New Testament, wherever it is given, rather than from the practices and experiences that it portrays.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Fourth, our motive in thus seeking to learn God’s purpose from the teaching of Scripture is practical and personal, not academic or controversial. We are brothers and sisters in the family of God. We love one another. We are concerned to know God’s will in order to embrace it ourselves and commend it to others. We have no desire to score cheap points off one another in theological debate.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("After these four simple introductory points regarding our approach, we are ready to consider in turn, from Scripture and in relation to contemporary discussion, what is meant by the promise of the Spirit (and whether this is the same as the “baptism” of the Spirit), the fullness of the Spirit, the fruit of the Spirit and the gifts of the Spirit.")])])])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 69
// module chunks = 0